<div data-qa="sedms-footer" class="sedms-footer">
  <span>Copyright © 2025 New York City Public Schools</span>
</div>